import {
  LegalClientEntity,
  LegalClientLegalHeadEntity,
} from 'api/types/entity';
import { useTranslation } from 'libs/i18n';
import { usePageTitle } from 'libs/navigation';

export const useLegalHeadPageTitle = (
  legalClient: LegalClientEntity | null,
  legalClientLegalHead: LegalClientLegalHeadEntity | null
) => {
  const { t } = useTranslation();

  let fullName = legalClientLegalHead
    ? t('client.legal.legalClientLegalHead.title', {
        name: legalClientLegalHead.fullName,
      })
    : '';

  fullName += fullName && legalClient ? ` - ${legalClient.fullName}` : '';

  usePageTitle(fullName);
};
